:host {
  display: block;
  block-size: 100%;
}

.country-selector {
  &__opener-img {
    inline-size: var(--cxsShell_NavigationIconSize);
    block-size: var(--cxsShell_NavigationIconSize);
  }

  &__opener-icon {
    --ds-icon-width: var(--cxsShell_NavigationIconSize);
    --ds-icon-heigh: var(--cxsShell_NavigationIconSize);
  }

  &__return-button {
    --ds-icon-color: var(--cxsShell_MobileMenuHeadingColor);
    --ds-icon-width: #{rem(1.125)}; //18px
  }

  .dropdown {
    margin: 0;
    padding: 0;
    list-style: none;

    &:focus {
      outline: none;
    }
  }

  .regions,
  .countries {
    display: flex;
    flex-direction: column;
    flex-grow: 1;



    &__title {
      display: block;
      padding-block-end: var(--cxs-spacer-m);
      border-block-end: 1px solid var(--cxsShell_MenuBorderColor);
      color: var(--cxsShell_MobileMenuHeadingColor);
      font: var(--cxsShell_MenuHeadingFont);
      text-align: center;
    }

    &__search {
      margin-block: var(--cxs-spacer-xs) var(--cxs-spacer-m);
      margin-inline: 0;
    }

    &__list {
      max-block-size: rem(20);
      margin-block: 0;
      margin-inline: calc(var(--cxs-spacer-s) * -1); // avoid clipped link focus outline
      padding-block: 0;
      padding-inline: var(--cxs-spacer-s);
      list-style-type: none;
      overflow-y: auto;

      li {
        padding-block: calc(var(--cxs-spacer-s) / 2);
        padding-inline: 0;
        border-block-end: 1px solid var(--cxsShell_MenuBorderColor);
      }
    }

    &__link {
      &::part(element) {
        inline-size: 100%;
      }

      .link {
        display: flex;
        justify-content: space-between;
        inline-size: 100%;
        block-size: auto;
        padding-block: calc(var(--cxs-spacer-s) / 2);
        padding-inline: 0;
        outline-offset: 0;
        color: var(--cxsShell_MenuTextColor);
        font: var(--cxsShell_MobileMenuFont);

        &:hover {
          text-decoration: underline;
        }
      }

      &.active {
        .link {
          font: var(--cxsShell_MenuHeadingFont);
        }
      }

      ds-icon {
        --ds-icon-width: var(--cxsShell_MobileMenuIconSize);
        --ds-icon-color: var(--cxsShell_MenuIconColor);
      }
    }

    &__top-section {
      border-block-end: solid 1px var(--cxsShell_MenuBorderColor);
    }
  }

  .countries{
    &__title {
      padding-block-end: var(--cxs-spacer-m);
      border-block-end: none;
    }

    &__back-to-region-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font: var(--cxsShell_MenuHeadingFont);

      .active-region-title {
        margin-inline-start: var(--cxs-spacer-s);
      }
    }

    &__back-to-region-button {
      margin-block: 0 var(--cxs-spacer-s);

      button {
        border: 0;
        background-color: transparent;
        color: inherit;
        padding-inline: 0;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        cursor: pointer;

        &:focus {
          outline: none;
        }

        &:focus-visible {
          outline: 2px solid var(--cxsContent_FocusColor);
          outline-offset: 0;
        }
      }

      .icon__wrapper {
        display: flex;
      }
    }

    &__list {
      padding: var(--cxs-spacer-s);

      li {
        padding: 0;
        border: none;
      }
    }
  }

  .last-visited {
    &__title {
      display: flex;
      align-items: center;
      margin-block: var(--cxs-spacer-xl) 0;
      margin-inline: 0;
      color: var(--cxsShell_MenuIconColor);
      font: var(--cxsShell_MobileMenuFont);
    }

    &__prefix {
      margin-inline-end: var(--cxs-spacer-xxs);
    }

    .link {
      font-family: var(--cxs-font-family-medium);
    }
  }

  .button-content-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    inline-size: 100%;
    text-align: start;
  }

  &--mobile {
    .menu {
      &__title {
        padding-block: var(--cxs-spacer-l);
        padding-inline: var(--cxs-spacer-m);
        font: var(--cxsShell_MobileMenuHeadingFont)
      }

      &__list {
        inline-size: 100%;
      }

      &__list-item {
        padding: var(--cxs-spacer-m);

        &:last-child {
          border-block-end: none;
        }
      }

      &__link {
        .link {
          padding: 0;
          text-decoration: none;

          &:hover,&:focus {
            text-decoration: none;
          }
        }

        &:focus {
          outline: 2px solid var(--cxsContent_FocusColor);
          outline-offset: calc(var(--cxs-spacer-xxs) * -1);
        }
      }
    }

    .regions {
      &__title {
        padding-block: var(--cxs-spacer-l);
        padding-inline: var(--cxs-spacer-m);
        font: var(--cxsShell_MobileMenuHeadingFont)
      }

      &__list {
        margin: 0;
        padding: 0;

         > li {
          padding: 0;

          &:last-child {
            border-block-end: 0;
          }
        }
      }

      &__link {
        &::part(element) {
          padding: var(--cxs-spacer-m);

          &:focus {
            outline: none;
          }
        }

        .link {
          -webkit-tap-highlight-color: transparent;
        }

        ds-icon {
          color: var(--cxsShell_MobileMenuIconColor);
        }
      }
    }

    .countries {
      &__title {
        order: 1;

        &--with-search {
          padding-block-end: 0;
        }
      }

      &__top-section {
        display: flex;
        flex-direction: column;
      }

      &__search {
        order: 2;
        box-sizing: border-box;
        margin: 0;
        padding: var(--cxs-spacer-m);
      }

      &__list {
        max-block-size: initial;
        margin: 0;
        padding: 0;

         > li {
           padding: 0;
           border-block-end: 1px solid var(--cxsShell_MenuBorderColor);

           &:last-child {
             border-block-end: none;
           }
        }
      }

      &__link .link {
        box-sizing: border-box;
        padding: var(--cxs-spacer-m);

        &:focus {
          outline: 2px solid var(--cxsContent_FocusColor);
          outline-offset: calc(var(--cxs-spacer-xxs) * -1);
        }
      }

      &__back-to-region-title {
        order: 3;

        .active-region-title {
          color: var(--cxsShell_MobileMenuHeadingColor);
          font: var(--cxsShell_MobileMenuHeadingFont)
        }
      }

      &__back-to-region-button {
        --button-width: 100%;
        inline-size: 100%;
        margin: 0;

        &::part(element) {
          padding: var(--cxs-spacer-m);
        }

        button {
          width: 100%;
          padding: var(--cxs-spacer-m);

          &:focus-visible {
            outline-offset: calc(var(--cxs-spacer-xxs) * -1);
          }
        }
      }
    }

    .last-visited {
      padding-block: calc(var(--cxs-spacer-xl) - var(--cxs-spacer-s));
      padding-inline: var(--cxs-spacer-m);

      &__title {
        margin: 0;
        color: var(--cxsShell_MenuTextColor);
        font: var(--cxsShell_MobileMenuFont);
      }

      &__prefix {
        margin-inline-end: 3px;
      }

      .link {
        padding-inline: 0;
        padding-block: var(--cxs-spacer-s);
        font-family: var(--cxs-font-family-book);
      }
    }

    .country-selector__return-button {
      --ds-icon-height: rem(1.25);
    }
  }
}

[data-mode='light'] {
  .button-content-wrapper {
    justify-content: normal;

    &::after {
      flex: 1;
      content: '';
    }
  }

  .country-selector {
    &__return-button {
      --ds-icon-width: var(--cxsShell_MobileMenuIconSize); //18px
      --ds-icon-height: var(--cxsShell_MobileMenuIconSize);
      flex: 1;
    }
  }

  &.country-selector--mobile {
    .countries__search {
      padding: 0;
      padding-block-end: rem(1);
    }

    .menu__list {
      > li:last-child {
          border-block-end: 1px solid var(--cxsShell_MenuBorderColor);
      }
    }

    .regions,
    .countries {
      padding: rem(1.5);
    }

    .regions__link::part(element),
    .countries__link .link,
    .countries__back-to-region-button::part(element) {
      padding-block: rem(1);
      padding-inline: rem(.5) rem(.75);
    }

    .countries__back-to-region-button button {
      padding-block: rem(1);
      padding-inline: rem(.5) rem(.75);
    }

    .menu__title {
      padding: 0;
      padding-block-end: rem(1.5);
    }

    .last-visited {
      padding-inline: rem(.5) rem(.75);
    }
  }
}
